import React from 'react';
import {SHAPE_COLOR_DEFAULT} from '../../../constants';

interface TriangleElementProps {
    color?: string;
    fill?: boolean;
    thickness?: number;
}

TriangleElement.defaultProps = {
    color: SHAPE_COLOR_DEFAULT,
    fill: false,
    thickness: 0.0625,
};

function TriangleElement(props: TriangleElementProps): JSX.Element {
    const {color, fill, thickness} = props;

    if (fill) {
        return (
            <div className="c-triangle c-triangle--filled">
                <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 120 120"
                    enableBackground="new 0 0 120 120"
                    xmlSpace="preserve"
                >
                    <polygon points="0.233,106.52 60,3 119.768,106.52 " fill={color || SHAPE_COLOR_DEFAULT} />
                </svg>
            </div>
        );
    }

    return (
        <div className="c-triangle">
            <svg
                version="1.1"
                id="Capa_1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                viewBox="0 0 72.72 72.719"
                xmlSpace="preserve"
            >
                <path
                    d="M72.72,65.686H0L36.36,7.034L72.72,65.686z M5.388,62.686h61.943L36.36,12.727L5.388,62.686z"
                    fill={color || SHAPE_COLOR_DEFAULT}
                    stroke={color || SHAPE_COLOR_DEFAULT}
                    strokeWidth={`${thickness}em`}
                />
            </svg>
        </div>
    );
}

export default TriangleElement;
